export const timeZone = 'Asia/Bangkok'
export const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const LongDateTimeFormat = 'ddd MMM D, YYYY HH:mm'
export const ShortDateTimeFormat = 'D MMM YYYY HH:mm'
export const LongDateFormat = 'ddd MMM D, YYYY'
export const ShortDateFormat = 'D MMM YYYY'
export const timeFormat = 'HH:mm'
export const getNumberOrdinal = (n) => {
   return ["st", "nd", "rd"][((n + 90) % 100 - 10) % 10 - 1] || "th"
}


// WEBPACK FOOTER //
// ./src/display/lib/setting.js